@if (breadcrumbsItems) {
  <div class="breadcrumbs-block" lgContainer>
    <lg-breadcrumb class="lg-breadcrumb" role="menuitem">
      @for (breadcrumbsItem of breadcrumbsItems; let i = $index; track i) {
        <lg-breadcrumb-item>
          @if (isLongList && i === 1) {
            <lg-breadcrumb-item-ellipsis />
          }

          @if (breadcrumbsItem.path) {
            <dotcom-frontend-link
              (click)="
                interactionClickEvent(
                  breadcrumbsItem.path,
                  breadcrumbsItem.name
                )
              "
              [ngClass]="{ active: currentActive === i }"
              [url]="breadcrumbsItem.path"
            >
              {{ breadcrumbsItem.name }}
            </dotcom-frontend-link>
          }
        </lg-breadcrumb-item>
      }
    </lg-breadcrumb>
  </div>
}
